import { isPrintQuery } from "./utils"

export default () => {
  isPrintQuery.addListener(mql => {
    // if the media is print
    if (mql.matches) {
      const paragraphs = document.querySelectorAll("p")

      paragraphs.forEach(p => {
        // Remove all empty paragraphs
        if (p.textContent.trim() === "") {
          p.remove()
        }
      })
    }
  })
}
